import { Outlet } from "react-router-dom";

const PushNotification = () => <Outlet/>

export default PushNotification